import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { alpha, styled } from '@mui/material/styles';
import { useCallback, useContext, useEffect, useState } from 'react';
import { ConfirmClasses,useNotify } from 'react-admin';
import CloseIcon from '@mui/icons-material/Close';
import { IconButton, Stack } from '@mui/material';
import { NUMBER } from '../../utils/Constants/MagicNumber';
import { useQueryClient } from 'react-query';
import { CustomFilterContext } from '../../layout/CustomFilterContext';
import { POST } from '../../services/HttpService';
import { LoadingButton } from '@mui/lab'
import { useIdentityContext } from '../../components/identity';
import { PROPAY_BULK_ACTION_API } from '../../utils/Constants/ConstantData';

export const PropayBulkActionModal = (props) => {
    const {
        isOpen = false,
        onClose,
        action,
        selectedIds,
        unselectAll
    } = props;
    const identity = useIdentityContext();
    const propayContext = useContext(CustomFilterContext);
    const notify = useNotify();
    const [isLoading,setIsLoading] = useState(false);
    const queryClient = useQueryClient();
    const url = PROPAY_BULK_ACTION_API[action];
    useEffect(()=>{},[propayContext?.showActionAlert])
    const handleConfirm = ()=>{
        if(selectedIds.length > NUMBER.HUNDRED){
            notify(`Limit exceeds: Select 100 items or fewer for bulk action`);
            onClose();
            return;
        }
        setIsLoading(true);
        const data = {
            propay_ids:selectedIds
        };
      POST(url,data).then((response:any[])=>{
            propayContext?.setBulkActionResponse(response);
            propayContext?.setShowActionAlert(true);
            queryClient.invalidateQueries(['propays', 'getList']);
            let successCount = NUMBER.ZERO;
            let cancelledCount = NUMBER.ZERO;
            let successList = [];
            if(response[NUMBER.ZERO].hasOwnProperty('is_success')){
             successList = response.filter(el=>el.is_success);
             successCount = successList.length;
            }else{
            successCount = selectedIds.length
            }
            setIsLoading(false);
            if(['Approve','Pending'].includes(action)){
                propayContext?.setAlertMessage(`${successCount}/${selectedIds.length} ${successCount > NUMBER.ONE ?'ProPays were':'ProPay was'}  ${action === 'Approve' ? `approved`:identity?.company?.is_started_status ? 'marked pending and started':'marked pending'}`);
            }else if(['Complete'].includes(action)){
                propayContext?.setAlertMessage(`${successCount}/${selectedIds.length} ${successCount > NUMBER.ONE ?'ProPays were':'ProPay was'}  ${'Completed'}`);
            }else{
              let cancelList = successList.filter(el=>el.propay_status === 'cancelled');
              cancelledCount = cancelList.length;
              let deleteCount =  Math.abs(successCount - cancelledCount);
              successCount ? propayContext?.setAlertMessage(`${deleteCount ? `${deleteCount}/${selectedIds.length} ${deleteCount > NUMBER.ONE ?'ProPays were deleted ':'ProPay was deleted'}`:''} ${cancelledCount && deleteCount ? '& ' : ''}
              ${cancelledCount ? `${cancelledCount}/${selectedIds.length} ${cancelledCount > NUMBER.ONE ?'ProPays were cancelled ':'ProPay was cancelled'}`:''}`) : propayContext?.setAlertMessage(`${successCount}/${selectedIds.length} ProPay was deleted`);
            }
            unselectAll('propays');
            onClose();
        }).catch(error=>{
            setIsLoading(false);
            notify(`Failure ! ${error.message}`);
        })
    }

    const handleClick = useCallback(e => {
        e.stopPropagation();
    }, []);

    return (
        <StyledDialog
            open={isOpen}
            onClose={onClose}
            onClick={handleClick}
            aria-labelledby="alert-dialog-title"
            className='common-dialog-modal alert-modal-confirmed'
        >

        <DialogTitle id="alert-dialog-title">
            <Stack flexDirection={'row'} justifyContent={'flex-end'}>
                <IconButton
                    sx={{top:-2,paddingLeft:2}}
                    color="primary"
                    aria-label="Alert Modal Confirmed"
                    onClick={onClose}
                >
                    <CloseIcon />
                </IconButton>
            </Stack>
            </DialogTitle>
            <DialogContent>
              <div className='alert-modal-strong'>
                Are you sure you want to "{(identity?.company?.is_started_status && action === 'Pending') ? `${action} or Start` : action}" the selected ({selectedIds.length}) {selectedIds.length > NUMBER.ONE ?'ProPays':'ProPay'} ?
               </div>
            </DialogContent>
            <DialogActions className='button-justified'>
            <Button className='cancel-button' onClick={()=>onClose()}>Cancel</Button>
            <LoadingButton loading={isLoading}  className={`${isLoading ? 'loader-button-bulk-action':''}`}  onClick={()=>handleConfirm()}>{!isLoading ?'Confirm':''}</LoadingButton>
            </DialogActions>

        </StyledDialog>
    );
};

const PREFIX = 'RaConfirm';

const StyledDialog = styled(Dialog, { name: PREFIX })(({ theme }) => ({
    [`& .${ConfirmClasses.confirmPrimary}`]: {
        color: theme.palette.primary.main,
    },

    [`& .${ConfirmClasses.confirmWarning}`]: {
        color: theme.palette.error.main,
        '&:hover': {
            backgroundColor: alpha(theme.palette.error.main, NUMBER.ZERO_POINT_ONE_TWO),
            // Reset on mouse devices
            '@media (hover: none)': {
                backgroundColor: 'transparent',
            },
        },
    },

    [`& .${ConfirmClasses.iconPaddingStyle}`]: {
        paddingRight: '0.5em',
    },
}));
